var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tooltip"},[_vm._t("default"),_c('span',{ref:"tooltip",staticClass:"Tooltiptext",class:("direction-" + _vm.direction),style:({
      marginLeft: ("-" + (_vm.direction === 'left' ? _vm.width : _vm.width / 2) + "px"),
      marginBottom: ("-" + (_vm.height / 2 - 1) + "px"),
    })},[_vm._t("title")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }